export default __webpack_public_path__ + "static/media/logon-meu-financiamento-solar.fe67124a.png";